import { createContext, useContext } from 'react';
import CustomLogger from './customLogger';

export const createLogger = (): CustomLogger => CustomLogger.getInstance();

export const LoggerContext = createContext<CustomLogger>({} as CustomLogger);

export const useLogger = (): CustomLogger => useContext(LoggerContext);
export const LoggerProvider = LoggerContext.Provider;
